import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core';
import './style.scss'
/**
 * Boat seats Component
 * @augments {Component<Props, State>}
 */
class TextFieldWithLabel extends Component {
  static propTypes = {
    pay: PropTypes.string,
    flex: PropTypes.string
  }

  render() {
    const { pay } = this.props;
    return (
      <div className="textfield-label " style={{flex:1}} >
        <div className="title">{pay}</div>
        <TextField {...this.props} />
      </div>
    )
  }
}

export default TextFieldWithLabel